import { all, put, call, takeEvery } from 'redux-saga/effects'
import { redirect } from 'redux-first-router'

import { showNotification, hideNotification } from '@/state/actions/notification'
import { ERROR } from '@/state/types/fetch'
import { routeLogin, routeDashboard } from '@/state/actions/routes'
import { userAuthenticated } from '@/state/actions/auth'
import {
  LOGIN,
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  CHECK,
  LOGOUT,
} from '@/state/types/auth'
import { ROUTE_LOGIN } from '@/state/types/routes'

export default authClient => {
  if (!authClient) return () => null
  function* handleAuth(action) {
    // TODO: optimize!
    const { type, payload, error, meta } = action // eslint-disable-line no-unused-vars
    switch (type) {
      case LOGIN: {
        try {
          yield put({ type: LOGIN_LOADING })
          const authPayload = yield call(authClient, LOGIN, payload)
          yield put({ type: LOGIN_SUCCESS, payload: authPayload })
          yield put(routeDashboard())
          // yield put(push(meta.pathName || '/'))
        } catch (e) {
          yield put({ type: LOGIN_FAILURE, error: e, meta: { auth: true } })
          const errorMessage =
            typeof e === 'string'
              ? e
              : typeof e === 'undefined' || !e.message ? 'i18n.auth.sign_in_error' : e.message
          yield put(showNotification(LOGIN, errorMessage, { timeout: 7000, type: 'warning' }))
        }
        break
      }
      case CHECK: {
        try {
          yield call(authClient, CHECK, payload)
          yield put(userAuthenticated())
        } catch (e) {
          yield call(authClient, LOGOUT)
          yield put(redirect({ type: ROUTE_LOGIN }))
          // yield put(
          //   replace({
          //     pathname: (e && e.redirectTo) || '/login',
          //     state: { nextPathname: meta.pathName }
          //   })
          // )
        }
        break
      }
      case LOGOUT: {
        yield call(authClient, LOGOUT)
        yield put(routeLogin())
        break
      }
      case ERROR:
        try {
          yield call(authClient, LOGIN_FAILURE, error)
        } catch (e) {
          yield call(authClient, LOGOUT)
          yield put(routeLogin())
          yield put(hideNotification())
        }
        break
      default:
        break
    }
  }
  return function* watchAuthActions() {
    yield all([
      takeEvery(action => action.meta && action.meta.auth, handleAuth),
      takeEvery(ERROR, handleAuth),
    ])
  }
}



// WEBPACK FOOTER //
// ./state/sagas/auth.js